const redeemRewardSkeletonStyle = {
    outerContainer: `flex flex-wrap gap-[7px] w-full`,
    skeleton: `bg-themeColor w-[100%] rounded-[20px] animate-pulse
               lg:w-[32%]
               md:w-[48%] 
    `,
}

export { redeemRewardSkeletonStyle }